"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ValueObject = exports.isValueObject = void 0;
const tslib_1 = require("tslib");
const is_primitive_1 = tslib_1.__importDefault(require("is-primitive"));
const shallow_equal_object_1 = require("shallow-equal-object");
const fast_safe_stringify_1 = tslib_1.__importDefault(require("fast-safe-stringify"));
const lodash_1 = require("lodash");
const debuggers_1 = require("../utils/debuggers");
const classDbg = debuggers_1.extendDebug(debuggers_1.getExtendedBaseDebug("ValueObject"));
exports.isValueObject = (v) => {
    return v instanceof ValueObject;
};
class ValueObject {
    // eslint-disable-next-line no-unused-vars
    constructor(props) {
        this._props = props;
    }
    get is() {
        return typeof this._props !== "undefined";
    }
    get deleted() {
        return this._props === null;
    }
    get value() {
        return this._props;
    }
    getTranslated(lang, name) {
        return lodash_1.get(this._props, [name, lang, "value"], "");
    }
    setTranslated(lang, name, value) {
        if (is_primitive_1.default(this._props)) {
            throw new Error("Value is primitive.");
        }
        lodash_1.set(this._props, [name, lang], { lang, value });
    }
    getAtPath(path, defaultValue) {
        return lodash_1.get(this._props, path, defaultValue);
    }
    setAtPath(path, value) {
        if (is_primitive_1.default(this._props)) {
            throw new Error("Value is primitive.");
        }
        lodash_1.set(this._props, path, value);
    }
    toString() {
        if (!this._props)
            return null;
        return fast_safe_stringify_1.default(this._props);
    }
    equals(vo) {
        if (vo == null) {
            return false;
        }
        if (vo._props === undefined) {
            return false;
        }
        return shallow_equal_object_1.shallowEqual(this._props, vo._props);
    }
    isPrimitive() {
        return is_primitive_1.default(this._props);
    }
    static handleValidationError(e, ref) {
        const dbg = classDbg("handleValidationError");
        dbg.vrbs("ref: %s %o", ref, e);
    }
}
exports.ValueObject = ValueObject;
//# sourceMappingURL=ValueObject.js.map